import Icon from "./IconBase.js";
const ArrowDownDisabledIcon = (props) => {
  return (
    <Icon width="16" height="16" viewBox="0 0 16 16" {...props}>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5287 6.02892C11.789 5.76857 12.2111 5.76857 12.4715 6.02892C12.7318 6.28927 12.7318 6.71138 12.4715 6.97173L8.47149 10.9717C8.2191 11.2241 7.81271 11.2329 7.5496 10.9918L3.5496 7.32509C3.27819 7.0763 3.25985 6.65459 3.50865 6.38317C3.75744 6.11176 4.17915 6.09343 4.45056 6.34222L7.98003 9.57757L11.5287 6.02892Z"
          fill="#AFAFAF"
        />
      </svg>
    </Icon>
  );
};
export default ArrowDownDisabledIcon;
